/**
 * GridBackground — full-bleed HUD grid layered behind a section.
 * Combines a fine grid + radial vignette for cinematic falloff.
 */
export default function GridBackground({
    fine = false,
    vignette = true,
    className = "",
}) {
    return (
        <div
            aria-hidden="true"
            className={`absolute inset-0 pointer-events-none ${className}`}
        >
            <div className={fine ? "absolute inset-0 tca-grid-bg-fine" : "absolute inset-0 tca-grid-bg"} />
            {vignette && <div className="absolute inset-0 tca-vignette" />}
        </div>
    );
}
